import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MainSidebar } from 'src/components';

// ========================================================================== //
// ================================= LOGIC ================================== //
// ========================================================================== //

export function MainContainer() {
  /**
   * @description - The sidebar visibility variable and toggle method to switch
   * the sidebar state from hidden to visible
   */
  const [sideBarVisibility, setSideBarVisibility] = useState<boolean>(false);
  const onSideBarToggle = () => {
    setSideBarVisibility(!sideBarVisibility);
  };

  return (
    <Suspense fallback={<div>Loading .... </div>}>
      <MainSidebar isMenuOpen={sideBarVisibility} onMenuToggle={onSideBarToggle} />
      <Outlet />
    </Suspense>
  );
}
